module.exports = __webpack_public_path__ + "static/media/loader.62c707d7.svg";